import AnnounceKit from 'announcekit-react';
import { useState } from 'react';
import * as ReactDOM from 'react-dom';

export const WHATS_NEW_CONTAINER_ID = 'whats-new-container';
/**
 * The announcekit-react library relies on React to attach event handlers and the entire "news" widget to the DOM.
 * Since this component is rendered inside the `WuiTopNav` component as a slot, which uses shadow-dom, `announcekit-react`
 * is failing to attach the needed event handlers. This component uses a React Portal to render `AnnounceKit` outside the shadow-dom
 * and attach it to its right position once everything is rendered.
 */
export function WhatsNewButton() {
  const [whatsNewSlot, setWhatsNewSlot] = useState<HTMLElement | null | undefined>(null);

  // This timeout defers the slot assignment to the next render in the event loop.
  setTimeout(() => {
    const slot = document.querySelector('wui-top-nav')?.shadowRoot?.getElementById(WHATS_NEW_CONTAINER_ID);
    setWhatsNewSlot(slot);
  });

  if (!whatsNewSlot) return null;

  return ReactDOM.createPortal(
    // widgetStyle will add margin to the notifications badge if it exists
    <AnnounceKit widget="https://announcekit.co/widgets/v2/1vfeec" widgetStyle={{ marginLeft: '0.25rem' }}>
      <span>What&apos;s new?</span>
    </AnnounceKit>,
    whatsNewSlot,
  );
}
